import React from 'react';
import '../Css/Course.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck,faAngleRight,faCircleDot } from '@fortawesome/free-solid-svg-icons';
import Seminar from './Seminar';
import MasterBanner from './MasterBanner';
// 1. Import Helmet from react-helmet-async
import { Helmet } from 'react-helmet-async';


function JoinUs() {
  const masterLogin = () => {
    const url = "https://homerepairexperthk.com/masterside";
    window.open(url,'_blank');
  }
  const seminarRegist = () => {
    const url = "https://homerepairlearning.com/seminarApply.php";
    window.open(url, '_blank');
  }  


  return (
    <div>
      <Helmet>
        <title>加盟維修王 | 師傅接單平台：增加柯打收入，極低加盟費</title>
        <meta name="description" content="誠邀各區水電、冷氣、油漆、裝修師傅加盟維修王！極低會費即可使用強大 App 接收全港維修柯打，自主管理工作時間，大幅增加每月收入。" /> 
        <meta property="og:title" content="立即加入維修王！全港師傅首選接單 App，生意源源不絕" />
        <meta property="og:description" content="擺脫傳統等客模式，手機即時接收維修訂單，簡單易用，助你建立個人專業口碑。" />
        <meta property="og:image" content="https://homerepairexperthk.com" />
        <meta property="og:url" content="https://homerepairexperthk.com" />
      </Helmet>
      
      <div className="Course-Wrapper">
      <div className="Course-Content">
        <div className="Course-Body">
            <MasterBanner/>
            <div className="Course-Body-Context" id="Course-Body-Context-Full">
              <div className="Section1">
                <div className="Section1Content">
                  <div className="Course-Body-Header" > &nbsp;<FontAwesomeIcon icon={faCircleDot} />&nbsp;誠邀維修精英加盟！打造你的高效率接單平台，坐享穩定收益</div>  
                    <div className="Content">
                      <p>
                        您是否維修技術精湛，却苦於訂單來源不穩定？                  
                      </p>
                      <p>
                      您是否每天奔波勞累，卻發現收入增長乏力？ 
                      </p>
                      <p>
                        您是否渴望擁有更便捷的工作方式，讓手藝創造更大價值？
                      </p>
                      現在，機會就在眼前！ 我們誠邀經驗豐富的維修師傅加入我們的專業家居維修平台，開啟事業新篇章！
                  </div>
              </div>
              <div className="JoinUs-Image2">
                <img src={require('../Image/MasterApp.png')} className="responsive-image" alt="維修王培訓課程"/>
              </div>
            </div>
            </div>
          
            {/*** Mobile */}
            <div className="Course-Body-Context" id="Course-Body-Context-Mobile">
              <div className="Section1">
              <div className="Section1Content">
                <div className="Course-Body-Header" > &nbsp;<FontAwesomeIcon icon={faCircleDot} />&nbsp;誠邀維修精英加盟！打造你的高效率接單平台，坐享穩定收益</div>  
                  <div className="Content">
                    <p>
                      您是否維修技術精湛，却苦於訂單來源不穩定？                  
                    </p>
                    <p>
                    您是否每天奔波勞累，卻發現收入增長乏力？ 
                    </p>
                    <p>
                      您是否渴望擁有更便捷的工作方式，讓手藝創造更大價值？
                    </p>
                    <h3>現在，機會就在眼前！ 我们誠邀經驗豐富的维修師傅加入我们的專業家居維修平台，開啟究事業新篇章！</h3>
                  </div>
              </div>
              <div className="JoinUs-Image2">
                <img src={require('../Image/MasterApp.png')} className="responsive-image" alt="維修王培訓課程"/>
              </div>
              </div>
            </div>

           <div className="Course-Body-Context">
              <div className="Course-Body-Header" > &nbsp;<FontAwesomeIcon icon={faCircleDot} />&nbsp;為什麼選擇加入我們？四大核心優勢助您創業！</div>  
              <div className="Content">
                <div className="Course-Body-SubHeader">
                    1.海量訂單，源源不斷：
                </div>
                <br/>
                 <div className="listItem">
                    <li>
                      <span id="ContentHeader">精準匹配：</span> 平台匯聚大量水務维修、水電维修、家具安装等需求的家庭用户。智能派單系统，根據据您的專業領域、位置和服務範圍，將最合適的訂單精確推送给您。
                    </li>
                    <br/>
                    <li>
                      <span id="ContentHeader">穩定客源：</span> 平台持續投入市场推廣，確保每日有充足的新訂單湧入，讓您的工作日程排得滿滿，收入更有保障。
                    </li>
                  </div>
              </div>
            
              <div className="Content">
                <div className="Course-Body-SubHeader">
                    2.提升收入，省心省力：
                </div>
                <br/>
                 <div className="listItem">
                    <li>
                      <span id="ContentHeader">收入可觀：</span>平台明碼實價，服務費用透明合理，讓您的手藝獲得更公平的回報。訂單量穩定增長，收入潛力遠超單打獨鬥。
                    </li>
                    <br/>
                    <li>
                      <span id="ContentHeader">降低成本： 收費合理！：</span> 無任何隱性收費。平台提供強大的技術支援（訂單管理、路線規劃、線上溝通等），助您大幅減少溝通成本和時間浪費，專注於核心維修工作。
                    </li>
                    <br />
                  </div>
              </div>
            
              <div className="Content">
                <div className="Course-Body-SubHeader">
                    3.專業形象，贏得信任:
                </div>
                <br/>
                 <div className="listItem">
                    <li>
                      <span id="ContentHeader">專業品牌：</span>依托平台強大的品牌影響力和用戶信任基礎，您將更容易獲得客戶的初步認可，降低獲客門檻。
                    </li>
                    <br/>
                    <li>
                      <span id="ContentHeader">展示平台：</span> 在平台上展示您的專業技能、服務案例和用戶好評，打造個人口碑，吸引更多回頭客和推薦訂單。
                    </li>
                    <br />
                    <li>
                      <span id="ContentHeader">標準化服務：</span> 平台提供專業的服務流程指導和規範，幫助您提升服務品質和用戶體驗，樹立專業可靠的上門維修服務形象。
                    </li>
                  </div>
              </div>
            
              <div className="Content">
                <div className="Course-Body-SubHeader">
                    4.強大支援，如虎添翼：
                </div>
                <br/>
                 <div className="listItem">
                    <li>
                      <span id="ContentHeader">智能工具：</span>專屬師傅APP，功能強大：輕鬆管理訂單、查看地圖導航、與客戶即時溝通、記錄服務過程，工作井井有條。
                    </li>
                    <br/>
                    <li>
                      <span id="ContentHeader">專業賦能：</span> 平台提供最新行業資訊、技術資料分享（如家電居維修知識、水電安裝技巧等），以及可選的技能提升培訓機會，助您持續精進，保持競爭力。
                    </li>
                    <br />
                    <li>
                      <span id="ContentHeader">專屬客服：</span> 遇到任何問題？專業的客服團隊隨時為您提供支援，解決後顧之憂。
                    </li>
                  </div>
            </div>
          
          </div>
               
          <div className="Course-Body-Context" id="Course-Body-Context-Full">
            <div className="Section2">
                <div className="JoinUs-Image2">
                <img src={require('../Image/MasterApp3.png')} className='responsive-image' alt="維修王培訓課程"/>
              </div>
              <div className="Section2Content">
                <div className="Course-Body-Header" > &nbsp;<FontAwesomeIcon icon={faCircleDot} />&nbsp;誰能成為我們的夥伴？</div>  
                <div className="Content">
                  <div className="listItem">
                    <li>
                     擁有家居維修經驗、水電維修、管道疏通、門窗維修、家具安裝/維修、牆面修補、開鎖換鎖等一項或多項專業技能。
                    </li>
                    <br/>
                    <li>
                       具備豐富的實際操作經驗和技術功底，能夠獨立、高效、高品質地完成各類家居維修任務。
                    </li>
                    <br/>
                    <li>
                      持有行業相關的有效證書（如電工牌、油漆牌等，根據工種要求）
                    </li>
                    <br />
                    <li>
                      具備良好的服務意識、溝通能力和職業素養，誠信可靠。
                    </li>
                    <br />
                    <li>
                      擁有維修王證書
                    </li>  
                  </div>
                </div>
              </div>  
            </div>  
          </div>

          <div className="Course-Body-Context" id="Course-Body-Context-Mobile">
            
              <div className="JoinUs-Image2">
                <img src={require('../Image/MasterApp3.png')} className='responsive-image' alt="維修王培訓課程"/>
              </div>
              <div className="Section2Content">
                <div className="Course-Body-Header" > &nbsp;<FontAwesomeIcon icon={faCircleDot} />&nbsp;誰能成為我們的夥伴？</div>  
                <div className="Content">
                  <div className="listItem">
                    <li>
                     擁有家居維修經驗、水電維修、管道疏通、門窗維修、家具安裝/維修、牆面修補、開鎖換鎖等一項或多項專業技能。
                    </li>
                    <br/>
                    <li>
                       具備豐富的實際操作經驗和技術功底，能夠獨立、高效、高品質地完成各類家居維修任務。
                    </li>
                    <br/>
                    <li>
                      持有行業相關的有效證書（如電工牌、油漆牌等，根據工種要求）
                    </li>
                    <br />
                    <li>
                      具備良好的服務意識、溝通能力和職業素養，誠信可靠。
                    </li>
                    <br />
                    <li>
                      擁有維修王證書
                    </li>  
                  </div>
                </div>
              </div>  
          </div>
          <div className="Course-Body-Context">
              <div className="JoinUs-Body-Header">
                <p>為了統一維修師傅水平,我們誠邀各師父進行技術測試,測試項目以日常能接觸到的家居維修項.</p>
                <div id="header">測試項目如下:</div>
              </div>
              <hr></hr>
              <div className="Course-Body-Content">
                <div className="Course-Body-List">
                  <div className="Course-Body-ListItem">
                    <ul>
                      <li>玻璃膠技巧</li>
                      <li>安裝鋁質天花</li>
                      <li>安裝鋁質天花</li>
                      <li>安裝廁所五金、瓦仔轉運用</li>
                      <li>安裝座廁（更換零件）</li>
                      <li>安裝洗手盆水龍頭</li>
                      <li>安裝浴缸水龍頭</li>
                      <li>更換洗手盆去水及隔氣</li>
                      <li>更換廁所門鎖</li>
                      <li>更換廁所抽氣扇</li>
                    </ul>
                </div>
                <div className="Course-Body-ListItem">
                    <ul>
                      <li>更換洗手盆水龍頭</li>
                      <li>更換抽油煙機</li>
                      <li>更換櫃桶路軌</li>
                      <li>更換門鉸</li>
                      <li>更換鋁窗鉸</li>
                      <li>更換鋁窗七字鉸</li>
                      <li>安裝吊櫃技巧</li>  
                      <li>安裝木地板</li>  
                      <li>修補瓷磚</li>
                      <li>批灰掃乳膠漆</li>
                    </ul>  
                </div>  
                <div className="Course-Body-ListItem">
                    <ul>
                      <li>石屎剝落維修</li>
                      <li>淘寶安裝燈</li>
                      <li>淘寶砌傢俬</li>
                      <li>清拆技巧</li>
                      <li>清潔家居技巧</li>
                      <li>清洗冷氣</li>  
                      <li>裝修維修報價技巧</li>  
                    </ul>  
                </div>  
              </div>
            </div>  
            <div className="Course-Body-Content">
                <div className="JoinUs-Result">
                <div className="JoinUs-Result-Text">
                    <div id="header">
                      <p>測試合格後,可獲盼發維修王認證,正式成為維修王.</p>
                      <p>各維修王可享用維修王平台接柯打</p>
                    </div>
                  </div>
                  <div className="JoinUs-Result-Logo">
                    <FontAwesomeIcon icon={faCircleCheck} style={{color:"#14A44D",}} />
                  </div>
                </div>
            </div>
          </div>

          <MasterBanner/>

          <div className="Course-Body-Context">
            <div className="Course-Body-Header" > &nbsp;<FontAwesomeIcon icon={faCircleDot} />&nbsp;如何收費？</div>  
            <div className="Content">
              <p>下載【維修王 (師傅版)】是完全免費</p>
              <p>我們不會在維修服務中收取費用</p>
              <p>師傅每次接柯打不論成功如否,均會扣取一個積分..</p>
              <p>每個積分價值港幣HK$30.</p>
              <p>註冊師傅可以入數至我們銀行戶口,然後透過【維修王 (師傅版)】App 傳送入數紙給我們便可</p>
              <p>一經確認後,積分便會自動增值...</p>
            </div>
            <div className="Content" id="AccountInformation">
              <p>戶口資料: 滙豐銀行戶口 No:124-792698-838 | 戶口名稱:設計匠裝修顧問有限公司(Starry Design Consultant Limited)</p>
              <p>轉數快: 受款人 電話號碼 91031197</p>
            </div>
                         
            
          </div>

          <div className="Course-Body-Context">
            <div id="header">
              <p>我們期待與各位手藝精湛的維修師傅攜手並進，共同服務萬千家庭，創造更大價值！</p>
              <p>加入我們，讓每一份手藝，都獲得應有的尊重與回報！</p>
            </div>  
          </div>
          {/*
          <div className="Course-Body-Context" id="Course-Body-Context-Full">
            <div class="Section3">
              <div class="Section3Content">
                <div id="header">
                  <p>馬上行動，搶佔先機！</p>
                  <p>掃碼下載【維修王 (師傅版)】，快速註冊，開啟接單之旅 ！</p>
                </div>  
              </div>
              <div className="JoinUs-Image2">
                <img src={require('../Image/masterQRCode.png')} className="responsive-image" alt="維修王"/>
              </div>
            </div>  
              
          </div>
           */} 
          
         
          <Seminar/>
         
          
        </div>
          
        </div>
      </div>
    </div>
    
  )
}

export default JoinUs
